'use client';

import React from 'react';
import Link from 'next/link';

export default function HomePage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6"
      style={{ background: 'linear-gradient(160deg, #f0f5ff 0%, #fafcff 60%, #f5f8ff 100%)' }}>
      <div className="w-full max-w-md text-center">
        {/* Logo */}
        <div className="w-20 h-20 rounded-2xl bg-primary flex items-center justify-center mx-auto mb-6 shadow-btn-primary">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        </div>

        <h1 className="text-3xl font-bold text-foreground mb-1">TEI Staff &amp; Faculty Time Clock</h1>
        <p className="text-muted-foreground text-base mb-2">The English Island</p>
        <p className="text-muted-foreground text-sm mb-10">Staff &amp; faculty time clock system</p>

        {/* Main actions */}
        <div className="flex flex-col gap-4 mb-8">
          <Link href="/kiosk"
            className="flex items-center justify-between bg-card border border-border rounded-2xl px-6 py-5 shadow-card-phone hover:border-primary hover:shadow-btn-primary transition-all group">
            <div className="text-left">
              <p className="font-bold text-foreground text-lg group-hover:text-primary transition-colors">Kiosk Display</p>
              <p className="text-muted-foreground text-sm mt-0.5">Tablet QR code display for the school</p>
            </div>
            <div className="w-10 h-10 rounded-xl bg-secondary flex items-center justify-center flex-shrink-0 ml-4 group-hover:bg-primary transition-colors">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                className="text-primary group-hover:text-white transition-colors">
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
                <line x1="8" y1="21" x2="16" y2="21" />
                <line x1="12" y1="17" x2="12" y2="21" />
              </svg>
            </div>
          </Link>

          <Link href="/login"
            className="flex items-center justify-between bg-primary rounded-2xl px-6 py-5 shadow-btn-primary hover:opacity-90 transition-all group">
            <div className="text-left">
              <p className="font-bold text-white text-lg">Employee Login</p>
              <p className="text-blue-200 text-sm mt-0.5">Clock in / out with your account</p>
            </div>
            <div className="w-10 h-10 rounded-xl bg-white bg-opacity-20 flex items-center justify-center flex-shrink-0 ml-4">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
            </div>
          </Link>
        </div>

        {/* Demo links */}
        <div className="flex items-center justify-center gap-6 text-sm">
          <Link href="/me" className="text-muted-foreground hover:text-primary transition-colors">
            My Dashboard
          </Link>
          <span className="text-border">·</span>
          <Link href="/q/demo-token" className="text-muted-foreground hover:text-primary transition-colors">
            QR Scan Demo
          </Link>
          <span className="text-border">·</span>
          <Link href="/admin" className="text-muted-foreground hover:text-primary transition-colors">
            Admin
          </Link>
        </div>

        <p className="text-xs text-muted-foreground mt-8 opacity-60">
          clock.theenglishisland.net · Staff &amp; faculty accounts only
        </p>
      </div>
    </div>
  );
}